/*==============================================================================
ACHG Collection Framework v2.0 Premium UI

File:
assets/achg-card-action.js

Purpose:
Premium Card Action Module (Impact 主题官方原生接口级高度兼容版)
- 支持单变体 AJAX 无缝直接加购
- 支持多变体 Options 弹窗阻断冒泡
- 通过原生 cart-provider 通道规避 Shopify 的 anti-bot 重定向校验

==============================================================================*/

(function () {

    'use strict';


    function initACHGAction() {


        // 1. 处理单规格 AJAX 直接加购按钮
        const cartButtons = document.querySelectorAll(
            '.achg-card-action--cart'
        );


        if (cartButtons.length > 0) {
            cartButtons.forEach(function (button) {

                if (button.dataset.achgReady) return;

                button.dataset.achgReady = 'true';

                button.addEventListener(
                    'click',
                    function (event) {

                        event.preventDefault();
                        event.stopPropagation(); // 阻止事件冒泡，防止触发卡片外层的商品详情页跳转链接

                        const variantId =
                            button.dataset.variantId;

                        if (!variantId) return;

                        addToCart(
                            variantId,
                            button
                        );

                    }
                );

            });
        }


        // 2. 处理多规格选项按钮
        const optionButtons = document.querySelectorAll(
            '.achg-card-action--options'
        );


        if (optionButtons.length > 0) {
            optionButtons.forEach(function (button) {

                if (button.dataset.achgReady) return;

                button.dataset.achgReady = 'true';

                button.addEventListener(
                    'click',
                    function (event) {
                        // 阻止事件冒泡。让自定义标签 <modal-trigger> 在当前页面拦截并触发选项弹窗，不跳转商品详情页
                        event.stopPropagation();
                    }
                );

            });
        }


    }



    function addToCart(
        variantId,
        button
    ) {


        button.classList.add(
            'is-loading'
        );

        // 1. 在 DOM 中寻找原装主题的购物车大管家 <cart-provider>
        const cartProvider = document.querySelector('cart-provider');

        // 2. 如果存在原装大管家，并且支持 publish 接口（Maestroo Impact 官方标准通道）
        if (cartProvider && typeof cartProvider.publish === 'function') {
            
            // 直接向原装通道发布加购事件，由官方底层代码处理所有多国路由、安全校验，并自动拉起抽屉
            cartProvider.publish('cart:add', {
                items: [
                    {
                        id: parseInt(variantId, 10),
                        quantity: 1
                    }
                ]
            });

            // 监听官方事件以关闭按钮的 Loading 动画
            const handleCartUpdate = function() {
                button.classList.remove('is-loading');
                document.removeEventListener('cart:updated', handleCartUpdate);
                document.removeEventListener('cart:error', handleCartUpdate);
            };

            document.addEventListener('cart:updated', handleCartUpdate);
            document.addEventListener('cart:error', handleCartUpdate);

        } else {
            
            // 3. 极稳健兜底方案：如果页面没有正确加载 <cart-provider>，则使用我们之前写的安全 fetch 方式进行加购
            fallbackAddToCart(variantId, button);

        }


    }


    // 兜底原生 AJAX 请求函数（采用 URL-encoded 格式，阻止 302 重定向到网页）
    function fallbackAddToCart(variantId, button) {
        const params = new URLSearchParams();
        params.append('id', variantId);
        params.append('quantity', '1');

        fetch(
            '/cart/add.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest', // 核心：强制声明是 AJAX 请求，阻止重定向到 HTML 购物车页
                    'Accept': 'application/json'          // 核心：声明只接受 JSON 响应
                },
                body: params
            }
        )
        .then(function (response) {
            if (!response.ok) {
                return response.json().then(function (err) {
                    throw new Error(err.description || 'Unable to add to cart');
                });
            }
            return response.json();
        })
        .then(function () {
            // 刷新计数器与拉起侧边滑出门
            document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
            );
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.show === 'function') {
                cartDrawer.show();
            }
        })
        .catch(function (error) {
            console.error('ACHG Cart Fallback Error:', error);
            alert('Could not add to cart: ' + error.message);
        })
        .finally(function () {
            button.classList.remove('is-loading');
        });
    }



    document.addEventListener(
        'DOMContentLoaded',
        initACHGAction
    );


})();